import { Card } from "primereact/card";
import { Skeleton } from "primereact/skeleton";
import { UnitStatusSummary } from "./UnitStatusSummaryCard";
import { UnitStatusByLocationCardProps } from "./types";
import { useAllUnitsByLocation } from "@api";

export function UnitStatusByLocationCard({
  locationId,
  locationName,
}: UnitStatusByLocationCardProps) {
  const { data: units = [], loading } = useAllUnitsByLocation(locationId);

  const getStatusCount = (status: string) =>
    units.filter((unit) => unit.status === status).length;

  const statusCounts = {
    rented: getStatusCount("Rented"),
    reserved: getStatusCount("Reserved"),
    available: getStatusCount("Available"),
    ready: getStatusCount("Ready"),
    dirty: getStatusCount("Dirty"),
  };

  return (
    <Card className="border-none surface-card shadow-3 border-round-2xl transition-all hover:shadow-6">
      <div className="flex align-items-center gap-2 mb-4">
        <i className="pi pi-map-marker text-xl text-blue-500" />
        <span className="text-lg font-bold text-900">{locationName}</span>
      </div>

      {loading ? (
        <Skeleton height="6rem" className="mb-2" />
      ) : (
        <UnitStatusSummary locationName={locationName} {...statusCounts} />
      )}
    </Card>
  );
}
